export const yCodes = [
    { value: "Y1", label: "klinické odpady z nemocníc, zdravotníckych stredísk a zariadení" },
    { value: "Y2", label: "odpady z výroby a prípravy farmaceutických výrobkov" },
    { value: "Y3", label: "odpadové farmaceutické látky, drogy a lieky" },
    { value: "Y4", label: "odpady z výroby, prípravy a použitia pesticídov a fytofarmák" },
    { value: "Y5", label: "odpady z výroby, prípravy a použitia chemických prostriedkov na ochranu dreva" },
    { value: "Y6", label: "odpady z výroby, prípravy a použitia organických rozpúšťadiel" },
    { value: "Y7", label: "odpady z tepelného spracovania a temperovacích operácií s obsahom kyanidov" },
    { value: "Y8", label: "odpadové minerálne oleje nevhodné na používanie podľa pôvodného určenia" },
    { value: "Y9", label: "odpady typu olej vo vode, uhľovodíky vo vode, emulzie" },
    { value: "Y10", label: "odpadové látky a predmety obsahujúce polychlórované bifenyly (PCB) a/alebo polychlórované terfenyly (PCT) a/alebo polybrómované bifenyly (PBB) alebo nimi znečistené" },
    { value: "Y11", label: "odpadové dechtové zvyšky vznikajúce pri čistení, destilácii a pyrolytickom spracovávaní" },
    { value: "Y12", label: "odpady z výroby, prípravy a použitia atramentov, farbív, pigmentov, farieb, lakov a náterov" },
    { value: "Y13", label: "odpady z výroby, prípravy a použitia živíc, latexov, zmäkčovadiel, glejov a lepidiel" },
    { value: "Y14", label: "odpadové chemické látky vznikajúce pri výskume a vývoji alebo výučbe, ktoré nie sú zatiaľ určené a/alebo sú nové a ich účinky na človeka alebo životné prostredie nie sú známe" },
    { value: "Y15", label: "látky výbušnej povahy, ktoré nepodliehajú iným právnym predpisom" },
    { value: "Y16", label: "látky z výroby, prípravy a použitia fotochemikálií a fotografických materiálov" },
    { value: "Y17", label: "odpady vznikajúce pri povrchovej úprave kovov a plastických materiálov" },
    { value: "Y18", label: "zvyšky vznikajúce pri priemyselnom zneškodňovaní odpadov" },
    { value: "Y19", label: "karbonyly kovov" },
    { value: "Y20", label: "berýlium, zlúčeniny berýlia" },
    { value: "Y21", label: "zlúčeniny šesťmocného chrómu" },
    { value: "Y22", label: "zlúčeniny medi" },
    { value: "Y23", label: "zlúčeniny zinku" },
    { value: "Y24", label: "arzén, zlúčeniny arzénu" },
    { value: "Y25", label: "selén, zlúčeniny selénu" },
    { value: "Y26", label: "kadmium, zlúčeniny kadmia" },
    { value: "Y27", label: "antimón, zlúčeniny antimónu" },
    { value: "Y28", label: "telúr, zlúčeniny telúru" },
    { value: "Y29", label: "ortuť, zlúčeniny ortuti" },
    { value: "Y30", label: "tálium, zlúčeniny tália" },
    { value: "Y31", label: "olovo, zlúčeniny olova" },
    { value: "Y32", label: "anorganické zlúčeniny fluóru okrem fluoridu vápenatého" },
    { value: "Y33", label: "anorganické kyanidy" },
    { value: "Y34", label: "roztoky kyselín a kyseliny v tuhej forme" },
    { value: "Y35", label: "roztoky zásad a zásady v tuhej forme" },
    { value: "Y36", label: "azbest (prach a vlákna)" },
    { value: "Y37", label: "organické zlúčeniny fosforu" },
    { value: "Y38", label: "organické kyanidy" },
    { value: "Y39", label: "fenoly, zlúčeniny fenolov vrátane chlórovaných fenolov" },
    { value: "Y40", label: "étery" },
    { value: "Y41", label: "halogénované organické rozpúšťadlá" },
    { value: "Y42", label: "organické rozpúšťadlá okrem halogénovaných rozpúšťadiel" },
    { value: "Y43", label: "všetky materiály obsahujúce polychlórovaný dibenzofurán" },
    { value: "Y44", label: "všetky materiály obsahujúce polychlórovaný dibenzo-p-dioxín" },
    { value: "Y45", label: "organohalogenove zlúčeniny iné ako látky uvedené v tejto tabuľke (napríklad Y39, Y41, Y42, Y43, Y44)" },
    { value: "Y46", label: "odpady z domácností" },
    { value: "Y47", label: "zvyšky vznikajúce pri spaľovaní domového odpadu" }
];